export default __webpack_public_path__ + "static/media/offer4.c272b29f.png";